export const GET_ACCESS_OPENINGS = 'GET_ACCESS_OPENINGS';
export const IS_FETCHING = 'IS_FETCHING';
export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_ACCESS_OPENING = 'SET_ACCESS_OPENING';